import { useState } from "react";
import { Check, ChevronDown, ChevronUp } from "lucide-react";
import { CORE_NEEDS } from "../lib/schemaFlip";

export const NEED_UNSURE = "unsure";

const Box = ({ on }) => (
  <span className={`mt-0.5 shrink-0 w-[22px] h-[22px] rounded-md border-2 grid place-items-center ${on ? "bg-t-brand border-t-brand text-t-onbrand" : "border-t-border2"}`}>
    {on ? <Check size={13} strokeWidth={3} /> : null}
  </span>
);

export function NeedPicker({ value, onChange }) {
  const [open, setOpen] = useState(null);
  const toggle = (key) => {
    if (key === NEED_UNSURE) return onChange(value.includes(NEED_UNSURE) ? [] : [NEED_UNSURE]);
    const rest = value.filter((v) => v !== NEED_UNSURE);
    onChange(rest.includes(key) ? rest.filter((v) => v !== key) : [...rest, key]);
  };
  return (
    <div className="flex flex-col gap-3 mt-4">
      {CORE_NEEDS.map((n) => {
        const count = value.filter((v) => v.startsWith(`${n.key}:`)).length;
        const isOpen = open === n.key;
        return (
          <div key={n.key} data-testid={`need-group-${n.key}`}
            className={`rounded-[20px] border overflow-hidden transition-colors ${count || isOpen ? "border-t-brand" : "border-t-border"} ${count ? "bg-t-brand3" : "bg-t-surface2"}`}>
            <button type="button" onClick={() => setOpen(isOpen ? null : n.key)} data-testid={`need-toggle-${n.key}`} className="w-full flex items-center gap-3 p-4 text-left">
              <span className="flex-1">
                <span className="block font-semibold text-t-on">{n.label}</span>
                <span className="block text-[13px] text-t-muted">{n.blurb}</span>
              </span>
              {count ? <span className="min-w-6 h-6 px-2 rounded-full bg-t-brand text-t-onbrand text-xs font-bold grid place-items-center">{count}</span> : null}
              {isOpen ? <ChevronUp size={18} className="text-t-brand" /> : <ChevronDown size={18} className="text-t-brand" />}
            </button>
            {isOpen
              ? n.items.map((item, i) => {
                  const k = `${n.key}:${item.need}`;
                  const on = value.includes(k);
                  return (
                    <button key={item.need} type="button" onClick={() => toggle(k)} data-testid={`need-${n.key}-${i}`}
                      className="w-full flex gap-3 px-4 py-3 text-left border-t border-t-border hover:bg-t-surface/60">
                      <Box on={on} />
                      <span>
                        <span className="block text-[15px] text-t-on">“{item.says}”</span>
                        <span className="block text-[13px] text-t-muted mt-0.5">{item.need}</span>
                      </span>
                    </button>
                  );
                })
              : null}
          </div>
        );
      })}
      <button type="button" onClick={() => toggle(NEED_UNSURE)} data-testid="need-unsure"
        className={`flex gap-3 items-center p-4 rounded-[20px] border bg-t-surface2 text-left ${value.includes(NEED_UNSURE) ? "border-t-brand" : "border-t-border"}`}>
        <Box on={value.includes(NEED_UNSURE)} />
        <span className="text-t-on">I'm not sure — show me all the schemas</span>
      </button>
    </div>
  );
}
